// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1174":"4deaa966","3705":"d08123e7","4142":"bffb92cf","5393":"be2f8351","8805":"94eab415"}[chunkId] + ".chunk.css";
};